import React, { useState, useContext, useCallback, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGetSwarmsInActionQuery } from "../../../../services/swarmsApi";
import { addOrUpdateSwarms, selectAllSwarms, updateSwarmCounter, removeSwarm } from '../../../../store/slices/swarmsInAction';
import styles from "./styles.module.css";
import { store } from '../../../../store';

// Custom hooks
import { useSwarmSignalR } from './hooks/useSwarmSignalR';

// Utils
import { mapSwarmToSwarmInActionRes } from './utils/swarmMappers';
import { createSignalRHandlers } from './signalRHandlers';

// Components
import { TopBar } from './components/TopBar';
import { MainContent } from './components/MainContent';
import SignalREncorehiveContext from "../../../../context/signalREncorehive";
import { useBuyManagers } from "../../../../customHooks/useBuyManagers";
import { CircularProgress } from "@mui/material";
import { useGetRequestActivityAdminToolQuery } from "../../../../services/requestActivityApi";
import { useSelector } from "react-redux";


export default function ActiveSwarms() {
  console.log('[ActiveSwarms], rendering');
  const {isLoading: isLoadingBuyManagers} = useBuyManagers();
  const dispatch = useDispatch();
  const { signalREncorehive } = useContext(SignalREncorehiveContext);

  const swarmsInAction = useSelector(selectAllSwarms);
  
  // Queries
  const { data, isLoading: isLoadingSwarmsInAction, isFetching } = useGetSwarmsInActionQuery(null, {refetchOnMountOrArgChange: true});
  const shouldFetchRequestActivity = !isLoadingSwarmsInAction && !isFetching && data?.length > 0;
  
  useGetRequestActivityAdminToolQuery( null, {skip: !shouldFetchRequestActivity, refetchOnMountOrArgChange: true});

  useEffect(() => {
    console.log("useEffect activeSwarms called first loading only")
    if (!isLoadingSwarmsInAction && data) {
      // Update all swarms in the store
      // Los swarms ya vienen con la propiedad isClosed desde el backend
      dispatch(addOrUpdateSwarms(data));
    }
  }, [data, isLoadingSwarmsInAction, dispatch]);
  
  // SignalR handlers setup
  const handleUpdateSwarmCounter = useCallback((swarmId, counterType, value) => {
    dispatch(updateSwarmCounter({ id: swarmId, counterType, value }));
  }, [dispatch]);
  
  const handlers = useMemo(() => createSignalRHandlers(
    dispatch,
    store.getState,
    handleUpdateSwarmCounter, 
    mapSwarmToSwarmInActionRes
  ), [dispatch, handleUpdateSwarmCounter]);
  
  useSwarmSignalR(signalREncorehive, handlers);
  if(isLoadingBuyManagers || isLoadingSwarmsInAction || isFetching){
    return (
      <CircularProgress size={50} /> //TODO: CHANGE FOR SKELETON
    );
  }

  return (
    <div className={styles.Container}>
      <TopBar /> {/*BuyManagerSelector and ActiveUserDisplay */}
      <MainContent/> {/* swarmsInActions and pendingBuyRequests */}
    </div>
  );
}